import {showToast} from "@core/component/toast/toast.js";

export default () => ({
    async init() {
        initFileAttachment(this.$el, this.$refs)
    }
});

const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'pdf'];

function isAllowedFile(file) {
    const extension = file.name.split('.').pop().toLowerCase();
    return ALLOWED_EXTENSIONS.includes(extension);
}

export function initFileAttachment(el, refs) {
    const channelMap = new Map();
    const zone = el;
    const deletedContainer = refs.deletedContainer;
    const input = refs.fileInput;
    const browse = refs.browseBtn;
    const list = refs.fileList;

    /* ---------- existing files---------- */
    list.querySelectorAll('.existing-file .remove-file').forEach(btn => {
        btn.addEventListener('click', () => {
            const li = btn.closest('.file-item');
            markAsDeleted(deletedContainer, li.dataset.attachmentId);
            li.remove();
        });
    });

    /* ---------- classic selection ---------- */
    browse.onclick = () => input.click();

    input.onchange = e => {
        addFiles(channelMap, e.target.files, list, input);
    };

    /* ---------- drag & drop ---------- */
    zone.ondragover = e => {
        e.preventDefault();

        if (!zone.disabled)
            zone.classList.add('dragover');
    };

    zone.ondragleave = () => zone.classList.remove('dragover');

    zone.ondrop = e => {
        e.preventDefault();
        zone.classList.remove('dragover');

        if (!zone.disabled)
            addFiles(channelMap, e.dataTransfer.files, list, input);
    };
}

function formatFileSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}

/* ===================================================== */

function buildAllowedExtensionsMessage(extensions) {
    const labels = [...new Set(
        extensions.map(ext => ext.toUpperCase())
    )];

    return getMessage('kibe.communication.attachment.error.file_type', [labels.join(', ')]);
}

function addFiles(channelMap, files, list, input) {
    [...files].forEach(file => {

        if (!isAllowedFile(file)) {

            showToast({
                type: 'danger',
                title: getMessage('kibe.communication.attachment.error.file_refused'),
                message: buildAllowedExtensionsMessage(ALLOWED_EXTENSIONS),
                delay: 5000
            });
            return;
        }

        const key = fileKey(file);
        if (channelMap.has(key)) return;

        channelMap.set(key, file);

        const li = document.createElement("li");
        li.className = "file-item";

        li.innerHTML = `
            <div class="file-info">
                <i class="fas fa-file-alt file-icon"></i>
                <div class="file-details">
                    <span class="file-name">${file.name}</span>
                    <span class="file-size">${formatFileSize(file.size)}</span>
                </div>
            </div>
            <div>
                <button type="button"
                        class="btn btn-sm btn-secondary me-2 preview-file"
                        title="${getMessage('kibe.communication.fragments.button.preview')}">
                    <i class="fas fa-eye"></i>
                </button>
                <button type="button"
                        class="btn btn-sm btn-danger remove-file"
                        title="${getMessage('kibe.communication.fragments.button.delete')}">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        `;

        // Preview a not-yet-uploaded file client-side via an object URL (no backend round-trip)
        li.querySelector(".preview-file").onclick = () => {
            window.dispatchEvent(new CustomEvent('open-attachment-preview', {
                detail: { url: URL.createObjectURL(file), filename: file.name }
            }));
        };

        li.querySelector(".remove-file").onclick = () => {
            channelMap.delete(key);
            li.remove();
            syncInputFiles(channelMap, input);
        };

        list.appendChild(li);
    });

    syncInputFiles(channelMap, input);
}


function syncInputFiles(channelMap, input) {
    const dt = new DataTransfer();
    channelMap.forEach(file => dt.items.add(file));
    input.files = dt.files;
}

function markAsDeleted(deletedContainer, id) {

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `deletedAttachments`;
    input.value = id;

    deletedContainer.appendChild(input);
}

function fileKey(file) {
    return `${file.name}-${file.size}-${file.lastModified}`;
}

export function addModelFiles(fileInfos, list, channel) {
    [...fileInfos].forEach(file => {

        const li = document.createElement("li");
        li.className = "file-item model-file";

        li.innerHTML = `
            <div class="file-info">
                <i class="fas fa-file-alt file-icon"></i>
                <div class="file-details">
                    <span class="file-name">${file.filename}</span>
                    <span class="file-size">${formatFileSize(file.size)}</span>
                </div>
                <input type="hidden" name="model-attachments-${channel}" value="${file.attachmentId}">
            </div>
            <button type="button"
                    class="btn btn-sm btn-secondary me-2 preview-file"
                    title="${getMessage('kibe.communication.fragments.button.preview')}">
                <i class="fas fa-eye"></i>
            </button>
            <a class="btn btn-sm btn-primary me-2"
               href="${window.NEXT_URL}/components/filedownload/${file.documentId}"
               title="${getMessage('kibe.communication.fragments.button.download')}">
                <i class="fas fa-download"></i>
            </a>
            <button type="button"
                    class="btn btn-sm btn-danger remove-file"
                    title="${getMessage('kibe.communication.fragments.button.delete')}">
                <i class="fas fa-times"></i>
            </button>
        `;

        li.querySelector(".preview-file").onclick = () => {
            window.dispatchEvent(new CustomEvent('open-attachment-preview', {
                detail: {
                    url: `${window.NEXT_URL}/components/filedownload/preview/${file.documentId}`,
                    filename: file.filename
                }
            }));
        };

        li.querySelector(".remove-file").onclick = () => {
            li.remove();
        };

        list.appendChild(li);
    });
}